import React from "react";
import { getClassByType } from "../../helpers/Utils";
import { statusesOptions } from "../enums/orderEnums";

const CaptifyCards = ({ orders }) => {
  return (
    <div className="captify-status-row">
      {statusesOptions
        .filter((element) => element.value !== "999")
        .map((element) => {
          const statusClass = getClassByType(element.value);
          const count = orders?.statusCounts?.[element.value] ?? 0;
          const badgeLabel = `${element.code} ${element.label}`;

          return (
            <div className="status-cards flex-grow-1" key={element.value}>
              <span
                className={`${statusClass.class} status-badge status-card-badge`}
                title={badgeLabel}
              >
                <span className="status-card-code w-100">{element.code}</span>
                {element.label}
              </span>
              <p className="status-card-count mb-0">{count}</p>
            </div>
          );
        })}
    </div>
  );
};

export default CaptifyCards;
